module.exports = __webpack_public_path__ + "static/media/dolar.97bc323c.png";